import { render, staticRenderFns } from "./ChevronRightIcon.vue?vue&type=template&id=0986567c&scoped=true&"
import script from "./ChevronRightIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChevronRightIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986567c",
  null
  
)

export default component.exports